import { call, put, takeLatest } from 'redux-saga/effects';
import {
  NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO,
  NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO_PENDING,
  NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO_SUCCESS,
  NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO_FAILURE,
} from '../../actionTypes';
import { conciliacaoBancariaService } from '../../service';
import { AlertError } from '@components/common/AlertToast';

function* sagaNewFilterNextPageContasPagar(action) {
  try {
    yield put({ type: NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO_PENDING });

    const { page, rows } = action;
    const { propriedadeId, dataInicio, dataFim, historico } = action.args || {};

    const response = yield call(
      conciliacaoBancariaService.buscarContasPagarPendentes,
      propriedadeId,
      dataInicio,
      dataFim,
      page,
      rows || 10,
      historico
    );

    // A API pode retornar os dados em response.data ou diretamente em response
    const responseData = response.data || response;

    yield put({
      type: NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO_SUCCESS,
      response: responseData,
      rows: rows || 10,
      page,
      args: { propriedadeId, dataInicio, dataFim, historico }
    });

  } catch (error) {
    yield put({
      type: NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO_FAILURE,
      error: error.message || 'Erro ao buscar próxima página'
    });

    const errorMessage = error.response?.data?.message || error.message || 'Erro ao buscar próxima página';
    AlertError(errorMessage);
  }
}

export default function* watchNewFilterNextPageContasPagar() {
  yield takeLatest(NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO, sagaNewFilterNextPageContasPagar);
}
